import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Crown, Loader2 } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { getUserPremiumVouchers } from '@/lib/actions/premiumActions';

interface PremiumVouchersProps {
  userId: string;
}

const PremiumVouchers: React.FC<PremiumVouchersProps> = ({ userId }) => {
  // Marr kuponët premium të përdoruesit me një trajtim të duhur të gabimeve
  const { data: premiumVouchersCount = 0, isLoading, error } = useQuery({
    queryKey: ['premiumVouchers', userId],
    queryFn: async () => {
      if (!userId) return 0;
      return getUserPremiumVouchers(userId);
    },
    enabled: !!userId,
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Crown className="mr-2 h-5 w-5 text-yellow-500" />
          Kuponët Premium
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex justify-center py-2">
            <Loader2 className="h-5 w-5 animate-spin text-gray-400" />
          </div>
        ) : (
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
              <span>Listime Premium falas në dispozicion:</span>
              <Badge variant="outline" className="px-3 py-1 ml-2 bg-yellow-50 text-yellow-700 font-medium">
                {premiumVouchersCount}
              </Badge>
            </div>
            <p className="text-sm text-gray-500 mt-2">
              Përdorni kuponët tuaj premium për të promovuar listimet tuaja dhe për të marrë më shumë dukshmëri.
              {premiumVouchersCount > 0 && " Mund t'i përdorni gjatë redaktimit të një listimi."}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PremiumVouchers;
